var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0H28V28H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    d: "M14 2.333C7.557 2.333 2.333 7.556 2.333 14c0 6.443 5.224 11.666 11.667 11.666S25.667 20.443 25.667 14c0-3.095-1.23-6.062-3.418-8.25-2.187-2.188-5.155-3.417-8.25-3.417zm0 17.5c-.644 0-1.167-.522-1.167-1.167 0-.644.523-1.166 1.167-1.166s1.167.522 1.167 1.166c0 .645-.523 1.167-1.167 1.167zm1.167-4.667c0 .645-.523 1.167-1.167 1.167s-1.167-.522-1.167-1.167V9.333c0-.644.523-1.167 1.167-1.167s1.167.523 1.167 1.167v5.833z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWarning);
export default __webpack_public_path__ + "static/media/Icons_Warning.8b7227de817baee05a2df59764ffe382.svg";
export { ForwardRef as ReactComponent };